import { LegendStates, MouseSelectionStates, SelectedParams } from "types";

import { mpcCompatibleHoverLegends, mpcCompatibleSelectionParams } from "./mpcHighlights";

export function totalRateCumHoverLegends(states: Partial<MouseSelectionStates>) {
  return mpcCompatibleHoverLegends(states);
}

export function totalRateCumSelectionParams(
  states: Partial<LegendStates>
): SelectedParams {
  return mpcCompatibleSelectionParams(states);
}
